export default "__VITE_ASSET__4eee4c79__"